import { BaseModel } from '@Core';
import { TypeInfo } from './Solar4gCamera';

export interface Solar4gSysInfo extends BaseModel {
    DevMac: string;

    DevName: string;

    DeviceName: string;

    Model: string;

    Hardware: string;

    Software: string;

    Mac: string;

    Sn: string;

    ExternalBatteryPack: ExternalBatteryPackMode;

    InfoType?: TypeInfo;
}

export enum ExternalBatteryPackMode {
    InternalBattery,
    ExternalPowerBattery,
}
